import { render, staticRenderFns } from "./door.vue?vue&type=template&id=31ab328f&scoped=true"
import script from "./door.vue?vue&type=script&lang=js"
export * from "./door.vue?vue&type=script&lang=js"
import style0 from "./door.vue?vue&type=style&index=0&id=31ab328f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ab328f",
  null
  
)

export default component.exports